import * as React from 'react';
import { Component } from 'react';
import { ConnectedRouter } from 'react-router-redux';
import history from '../../history';
import { Redirect, Route, RouteProps, Switch } from 'react-router';
import Dashboard from '../Dashboard/Dashboard';
import CreditReport from '../CreditReport/CreditReport';
import AddDebt from '../AddDebt/AddDebt';
import Contact from '../Contact/Contact';
import FAQ from '../FAQ/FAQ';
import Billing from '../Billing/Billing';
import Callback from '../Callback/Callback';
import { connect, Dispatch } from 'react-redux';
import { SET_MOBILE } from '../../ducks/actions';
import Admin from '../Admin/Admin';
import DebtDetails from '../DebtDetails/DebtDetails';
import SettlementSchedule from '../SettlementSchedule/SettlementSchedule';
import Onboard from '../Onboard/Onboard';
import auth from '../../auth/auth';
import { AscendState } from '../../ducks';
import YourAnalyst from '../MeetAnalyst/YourAnalyst';
import AccountsTracker from '../SpendingTracker/AccountsTracker';
import SpendingTracker from '../SpendingTracker/SpendingTracker';
import DebtPayoffTracker from '../DebtPayoffTracker/DebtPayoffTracker';
import StartHere from '../StartHere/StartHere';
import HelpPage from '../HelpPage/HelpPage';
import QuizResults from '../QuizResults/QuizResults';

const handleAuthentication = ({ location }: RouteProps) => {
  const hasTokens = /access_token|id_token|error/.test(location!.hash);
  
  if (hasTokens) {
    auth.handleAuthentication();
  }
};

interface RouterProps {
  hasSubmittedAgreement?: boolean;
  setIsMobile: (isMobile: boolean) => void;
}

class Router extends Component<RouterProps> {
  public componentDidMount() {
    this.calculateMobile();
    window.addEventListener('resize', () => this.calculateMobile());
  }

  public calculateMobile() {
    this.props.setIsMobile(window.innerWidth <= 900);
  }

  public render() {
    return (
      <ConnectedRouter history={history}>
        <Switch>
          <Redirect from='/' exact to='/startHere' />
          <Route path='/accountsTracker' component={AccountsTracker} />
          <Route path='/addDebt' component={AddDebt} />
          <Route path='/contact' component={Contact} />
          <Route path='/creditReport' component={CreditReport} />
          <Route path='/debt/:id' exact component={DebtDetails} />
          <Route path='/debt/:id/schedule' exact component={SettlementSchedule} />
          <Route path='/debtPayoffTracker' exact component={DebtPayoffTracker} />
          <Route path='/HelpPage' exact component={HelpPage} />

          {/*<Route path="/faq" component={FAQ} />*/}
          <Route path='/startHere' component={StartHere} />
          <Route path='/onboard' component={Onboard} />
          <Route path='/spendingTracker' component={SpendingTracker} />
          <Route path='/home' component={Dashboard} />
          <Route path='/yourAnalyst' component={YourAnalyst} />
          <Route path='/quizresults' component={QuizResults} />

          <Route
            path='/admin'
            render={() => {
              if (localStorage.getItem('isAdmin') === 'true') {
                return <Admin />;
              } else {
                return <Redirect to={{ pathname: '/startHere' }} />;
              }
            }}
          />
          {/* TODO: Add back once CFT Pay is complete */}
          {/*<Route path="/billing" component={Billing} />*/}
          <Route
            path='/callback'
            render={(props) => {
              handleAuthentication(props);
              return <Callback />;
            }}
          />
        </Switch>
      </ConnectedRouter>
    );
  }
}

const mapStateToProps = (state: AscendState) => ({
  hasSubmittedAgreement: state.user.data.submittedAgreement
});
const mapDispatchToProps = (dispatch: Dispatch) => ({
  setIsMobile: (isMobile: boolean) => dispatch({ type: SET_MOBILE, isMobile })
});
export default connect<any>(mapStateToProps, mapDispatchToProps)(Router) as any;
